const DEFAULT_CURRENCY = "INR";

export function normalizeCurrency(currency?: string | null): string {
  const code = currency?.trim().toUpperCase();
  return code && /^[A-Z]{3}$/.test(code) ? code : DEFAULT_CURRENCY;
}

export function currencySymbol(currency?: string | null): string {
  const code = normalizeCurrency(currency);
  try {
    return new Intl.NumberFormat("en", { style: "currency", currency: code, currencyDisplay: "narrowSymbol" })
      .formatToParts(0).find((item) => item.type === "currency")?.value || code;
  } catch { return code; }
}

export function formatCurrency(value: number | null | undefined, currency?: string | null, maximumFractionDigits = 2): string {
  if (value == null || !Number.isFinite(Number(value))) return "Not available";
  const code = normalizeCurrency(currency);
  try {
    return new Intl.NumberFormat("en-IN", { style: "currency", currency: code, currencyDisplay: "narrowSymbol", maximumFractionDigits }).format(Number(value));
  } catch {
    return `${currencySymbol(code)}${Number(value).toLocaleString("en-IN", { maximumFractionDigits })}`;
  }
}
